// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VXyVU","buttons":"styles_buttons__3Gp8i"};